import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts";
import { TDocumentDefinitions } from "pdfmake/interfaces";
import { QRCodeSVG } from "qrcode.react";
import ReactDOMServer from "react-dom/server";
import { getAssinaturaResponsavel } from "../../../../../../services/director.service";

(pdfMake as any).vfs = pdfFonts?.pdfMake?.vfs;

function getBase64Image(img: Blob) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(img);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });
}

function rotateImage(base64: any, angleDeg: any) {
    return new Promise((resolve) => {
        const img = new Image();
        img.src = base64;
        img.onload = () => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");

            const angle = angleDeg * (Math.PI / 120);

            canvas.width = img.height;
            canvas.height = img.width;

            ctx?.translate(canvas.width / 2, canvas.height / 2);
            ctx?.rotate(angle);
            ctx?.drawImage(img, -img.width / 2, -img.height / 2);

            resolve(canvas.toDataURL());
        };
    });
}

const CertificadoAnaliticoPfd = async (dados: any) => {
    // ASSINATURA DO DIRECTOR GERAL
    const assinatura = await getAssinaturaResponsavel("Director Geral");


    const today = new Date();
    const dia = today.getDate();
    const mes = today.toLocaleString("pt-BR", { month: "long" }).toUpperCase();
    const ano = today.getFullYear();

    const imageBlob = await fetch("/img/logo/InsigniaAngola.png").then((res) => res.blob());
    const imageBase64 = (await getBase64Image(imageBlob)) as string;
    const imageConvert = await fetch("/img/logo/logoArmed.png").then((res) => res.blob());
    const imageArmed = (await getBase64Image(imageConvert)) as string;

    const imagemAmostra = await fetch("/img/logo/logoArmed.png").then((res) => res.blob());
    const amostraImg = (await getBase64Image(imagemAmostra)) as string;

    const rotatedImage = await rotateImage(imageArmed, -45);

    function gerarTabelaMetodoteste(dados: any) {
        const table = {
            headerRows: 1,
            widths: ['15%', '18%', '12%', '55%'],
            body: [
                [
                    {
                        text: 'Método de Teste',
                        fillColor: '#BDD6EE',
                        bold: true,
                        color: '#000',
                        alignment: 'center',
                        fontSize: 10,
                        margin: [0, 3]
                    },
                    {
                        text: 'Especificação',
                        fillColor: '#BDD6EE',
                        bold: true,
                        color: '#000',
                        alignment: 'center',
                        fontSize: 10,
                        margin: [0, 3]
                    },
                    {
                        text: 'Resultado',
                        fillColor: '#BDD6EE',
                        bold: true,
                        color: '#000',
                        alignment: 'center',
                        fontSize: 10,
                        margin: [0, 3]
                    },
                    {
                        text: 'Comentários',
                        fillColor: '#BDD6EE',
                        bold: true,
                        color: '#000',
                        alignment: 'center',
                        fontSize: 10,
                        margin: [0, 3]
                    }
                ],
                [
                    { text: 'Visual', bold: true, fontSize: 10, },
                    { text: 'Compatível com o padrão de referência', fontSize: 10, },
                    {
                        text: `${dados?.inspeccaoVisualFisica?.resultado}`,
                        alignment: 'center',
                        bold: true,
                        fontSize: 10,
                    },
                    {
                        text: `${dados?.inspeccaoVisualFisica?.outrasObservacoes}`,
                        fontSize: 10,
                    }
                ],
                [{ text: 'Uniformidade', bold: true, fontSize: 10, }, { text: `Compatível com o padrão de referência`, fontSize: 10 }, { text: ``, fontSize: 10 }, { text: ``, fontSize: 9 },],
                [{ text: 'Dissolução', bold: true, fontSize: 10, }, { text: `>= []% em [] minutos`, fontSize: 10 }, { text: ``, fontSize: 10 }, { text: ``, fontSize: 10 }],
                [{ text: 'pH', bold: true, fontSize: 10, }, { text: `[valor] +/- [valor] `, fontSize: 10 }, { text: ``, fontSize: 10 }, { text: ``, fontSize: 10 }],
                [{ text: 'Friablidade', bold: true, fontSize: 10, }, { text: `<=[valor]%`, fontSize: 10 }, { text: ``, fontSize: 10 }, { text: ``, fontSize: 10 }],
                [{ text: 'Dureza', bold: true, fontSize: 10, }, { text: `>=[valor]%`, fontSize: 10 }, { text: ``, fontSize: 10 }, { text: ``, fontSize: 10 }],
                [{ text: 'Cromatografia em Camada Fina Delgada', bold: true, fontSize: 10, }, { text: `[valor] +/- [valor]%`, fontSize: 10 }, { text: ``, fontSize: 10 }, { text: ``, fontSize: 9 }],
                [{ text: 'Identificação (HPLC)', bold: true, fontSize: 10, }, { text: `[valor] +/- [valor]%`, fontSize: 10 }, { text: ``, fontSize: 10 }, { text: ``, fontSize: 10 }],
                [{ text: 'Identificação (UV-Visível)', bold: true, fontSize: 10, }, { text: `[valor] +/- [valor]%`, fontSize: 10 }, { text: ``, fontSize: 10 }, { text: ``, fontSize: 10 }],
            ]
        };

        return table;
    }

    const qrCodeSVG = ReactDOMServer.renderToStaticMarkup(
        <QRCodeSVG
            value={`https://armed.gov.ao/verifica-documento/certificado/${dados?._id}`}
            type="svg"
        />
    );

    const docDefinition: TDocumentDefinitions = {
        pageSize: "A4",
        pageMargins: [45, 40, 45, 80],

        content: [
            {
                columns: [
                    {
                        stack: [
                            {
                                svg: qrCodeSVG,
                                width: 55,
                                height: 55,
                                margin: [0, 0, 0, 0],
                            },
                        ],
                        alignment: "left",
                        style: "header",
                    },
                    {
                        image: imageBase64 as string,
                        width: 80,
                        height: 80,
                        alignment: "center",
                        margin: [0, 0, 0, 0],
                    },
                    {
                        width: '45%',
                        stack: [
                            {
                                text: "VISTO",
                                fontSize: 10,
                                margin: [30, 0, 0, 0],
                            },
                            {
                                text: "DIRECTOR GERAL",
                                fontSize: 10,
                                margin: [10, 0, 0, 0],
                            },
                            {
                                text: assinatura?.nome ?? '',
                                fontSize: 10,
                                margin: [0, 0, 0, 0],
                            },
                        ],
                        margin: [100, -4, 0, 0],
                    },

                ]
            },

            { text: "Laboratório Nacional de Controlo de Qualidade ", style: "header" },
            { text: "de Medicamentos e Tecnologias de Saúde", style: "header" },
            { text: "_______________________________________________________________________", style: "header" },
            {
                text: `CERTIFICADO DE ANÁLISE`,
                fontSize: 11,
                bold: true,
                alignment: 'center',
                style: "body",
                margin: [0, 15, 0, 6],
            },
            {
                columns: [
                    {
                        text: [
                            { text: `Nº do Certificado: `, bold: true },
                            `${dados?.numeroCertificado}/LNCQ/ARMED/${new Date(dados?.certificadoEmitedAt).getFullYear()}`
                        ],
                        style: "body",
                        margin: [0, 5, 0, 3],
                    },
                    {
                        text: [
                            { text: `Data de Emissão: `, bold: true, margin: [20, 0, 0, 0], },
                            `${new Date(dados?.certificadoEmitedAt).toLocaleDateString('pt-BR')}`,
                        ],
                        style: "body",
                        margin: [10, 5, 0, 3],
                    },
                ]
            },
            {
                text: [
                    { text: `1. Número de referência do Cliente: `, bold: true },
                    `${''}`,
                ],
                style: "body",
                margin: [0, 5, 0, 5],
            },
            {
                text: [
                    { text: `2. Número de registo: `, bold: true },
                    `${''}`,
                ],
                style: "body",
                margin: [0, 5, 0, 5],
            },
            {
                text: [
                    { text: `3. Nome do Medicamento: `, bold: true },
                    `${dados?.producto?.nome}`,
                ],
                style: "body",
                margin: [0, 5, 0, 5],
            },
            {
                text: [
                    { text: `4. Substância activa: `, bold: true },
                    `${dados?.substanciaActiva}`,
                ],
                style: "body",
                margin: [0, 5, 0, 5],
            },
            {
                text: [
                    { text: `5. Dosagem: `, bold: true },
                    `${dados?.producto?.dosagemConcentracao}`,
                ],
                style: "body",
                margin: [0, 5, 0, 5],
            },
            {
                text: [
                    { text: `6. Fabricante: `, bold: true },
                    `${dados?.producto?.fabricante}`,
                ],
                style: "body",
                margin: [0, 5, 0, 5],
            },
            {
                text: [
                    { text: `7. Endereço do fabricante: `, bold: true },
                    `${dados?.producto?.enderecoFabricante}`,
                ],
                style: "body",
                margin: [0, 5, 0, 5],
            },
            {
                text: [
                    { text: `8. Forma Farmacêutica: `, bold: true },
                    `${dados?.producto?.formaFarmaceutica}`,
                ],
                style: "body",
                margin: [0, 5, 0, 5],
            },
            {
                text: [
                    { text: `9. Nº do Lote: `, bold: true },
                    `${dados?.producto?.lote}`,
                ],
                style: "body",
                margin: [0, 5, 0, 5],
            },
            {
                text: [
                    { text: `10. Data de Fabrico: `, bold: true },
                    `${new Date(dados?.producto.dataFabrico).toLocaleDateString('pt-BR')}`,
                ],
                style: "body",
                margin: [0, 5, 0, 5],
            },
            {
                text: [
                    { text: `11. Data de Validade: `, bold: true },
                    `${new Date(dados?.producto.dataValidade).toLocaleDateString('pt-BR')}`,
                ],
                style: "body",
                margin: [0, 5, 0, 5],
            },
            {
                text: [
                    { text: `12. Quantidade de amostra recebida: `, bold: true },
                    `${dados?.quantidadeAmostras}`,
                ],
                style: "body",
                margin: [0, 5, 0, 5],
            },
            {
                text: [
                    { text: `13. Data de recepção da amostra: `, bold: true },
                    `${new Date(dados?.dataEntregueAnalista).toLocaleDateString('pt-BR')}`,
                ],
                style: "body",
                margin: [0, 5, 0, 5],
            },
            {
                text: [
                    { text: `14. Condiçōes de armazenamento: `, bold: true },
                    `${''}`,
                ],
                style: "body",
                margin: [0, 5, 0, 5],
            },
            {
                text: [
                    { text: `15. Data do teste: `, bold: true },
                    `${new Date(dados?.dataEnsaios).toLocaleDateString('pt-BR')}`,
                ],
                style: "body",
                margin: [0, 5, 0, 5],
            },
            {
                text: [
                    { text: `16. Nome do Cliente: `, bold: true },
                    `${dados?.solicitacaoAnalise?.nome}`,
                ],
                style: "body",
                margin: [0, 5, 0, 5],
            },
            {
                text: [
                    { text: `17. Local da recolha: `, bold: true },
                    `${dados?.localAnalise}`
                ],
                style: "body",
                margin: [0, 5, 0, 5],
            },
            {
                text: [
                    { text: `18. Data da recolha: `, bold: true },
                    `${new Date(dados?.dataEnsaios).toLocaleDateString('pt-BR') ?? ''}`
                ],
                style: "body",
                margin: [0, 5, 0, 5],
            },
            {
                text: [
                    { text: `19. Endereço do Cliente: `, bold: true },
                    `${dados?.solicitacaoAnalise?.provincia}, ${dados?.solicitacaoAnalise?.municipio}, ${dados?.solicitacaoAnalise?.bairro}`,
                ],
                style: "body",
                margin: [0, 5, 0, 5],
            },
            {
                text: [
                    { text: `20. Contacto do Cliente: `, bold: true },
                    `${dados?.solicitacaoAnalise?.tel} - ${dados?.solicitacaoAnalise?.email}`,
                ],
                style: "body",
                margin: [0, 5, 0, 5],
            },
            { table: gerarTabelaMetodoteste(dados) },
            {
                text: 'CONCLUSÃO',
                alignment: "left",
                style: "body",
                bold: true,
                fontSize: 11,
                margin: [0, 25, 0, 0],
            },
            {
                text: [
                    `O lote `,
                    { text: `${dados?.producto?.lote ?? " - "} `, bold: true },
                    `do medicamneto`,
                    { text: ` ${dados?.producto?.nome ?? " - "}`, bold: true },
                    ` encontra - se em conformidade com as especificaçōes estabelecidas e cumpre os requisitos de qualidade da OMS.`,
                ],
                alignment: "justify",
                style: "body",
                margin: [0, 5, 0, 25],
            },

            {
                columns: [
                    {
                        width: '*',
                        stack: [
                            {
                                text: "Analista",
                                alignment: "center",
                                style: "signature",
                                margin: [0, 30, 0, 10],
                            },
                            {
                                text: `${dados?.analista?.dadosPessoais?.nome}`,
                                alignment: "center",
                                style: "body",
                            }
                        ]
                    },
                    {
                        width: '*',
                        stack: [
                            {
                                text: "Supervisor",
                                alignment: "center",
                                style: "signature",
                                margin: [0, 30, 0, 10],
                            },
                            {
                                text: `${dados?.revisor?.dadosPessoais?.nome}`,
                                alignment: "center",
                                style: "body",
                            }
                        ]
                    },
                    {
                        width: '*',
                        stack: [
                            {
                                text: "Chefe de Dpto",
                                alignment: "center",
                                style: "signature",
                                margin: [0, 30, 0, 10],
                            },
                            {
                                text: ``,
                                alignment: "center",
                                style: "body",
                            }
                        ]
                    },
                ]
            },

            {
                text: `Laboratório Gerais: `,
                fontSize: 11,
                bold: true,
                style: "body",
                margin: [0, 5, 0, 5],
            },
            {
                ul: [
                    'Este certificado analítico é válido apenas para o lote e amostra especificados.',
                    'Os métodos de teste utilizados estão de acordo com as diretrizes da OMS e outras normas internacionais.',
                    'Os resultados dos testes são válidos apenas para a amostra recebida e nas condições em que foi testada.',
                    'Este certificado não pode ser reproduzido parcialmente ou totalmente sem autorização do laboratório.'
                ],
                margin: [0, 10, 0, 10],
                fontSize: 10
            }

        ],

        footer: () => {
            return [
                {
                    text: "____________________________________________________________________________________________________",
                    style: "",
                    margin: [0, 0, 0, 0],
                    bold: true,
                    alignment: "center",
                },
                {
                    columns: [
                        {
                            stack: [
                                {
                                    text: "Rua Cmdt. Che Guevara nº 6/86º Bº Maculusso, Ingombota",
                                    style: "",
                                    margin: [0, 10, 0, 0],
                                    bold: true,
                                },
                                {
                                    text: "Tel.: +244 938 120 372",
                                    style: "",
                                    margin: [0, 0, 0, 0],
                                    bold: true,
                                },
                                {
                                    text: "Email: geral@armed.minsa.gov.ao LUANDA-ANGOLA",
                                    style: "",
                                    margin: [0, 0, 0, 0],
                                    bold: true,
                                },
                            ],
                            width: "70%",
                            fontSize: 9,
                            alignment: "left",
                        },
                        {
                            width: "30%",

                            stack: [
                                {
                                    image: imageArmed as string,
                                    width: 100,
                                    height: 40,
                                    alignment: "center" as "center",
                                },
                            ],
                        },
                    ],
                    alignment: "center",
                    fontSize: 8,
                    margin: [50, 0, 50, 0],
                },
            ];
        },

        background: function (currentPage, pageSize) {
            return {
                image: rotatedImage as string,
                width: 300,
                height: 600,
                opacity: 0.1,
                alignment: "center",
                margin: [0, 60, 0, 0],
            };
        },

        images: {
            mySuperImage: `data:image/jpeg;base64,/${imageBase64}`,
            // in browser is supported loading images via url (https or http protocol) (minimal version: 0.1.67)
            snow: "/img/logo/logoArmed.png",
            // is supported loading images via url with custom headers (minimal version: 0.2.5)
            strawberries: {
                url: "/img/logo/logoArmed.png",
                headers: {
                    myheader: "123",
                    myotherheader: "abc",
                },
            },
        } as Record<string, any>,

        styles: {
            header: {
                fontSize: 11,
                bold: true,
                alignment: "center",
                margin: [0, 5, 0, 0],
            },
            body: {
                fontSize: 10,
                alignment: "justify",
                margin: [0, 0, 0, 10],
                lineHeight: 1.3,
            },
            bodyTabela: {
                fontSize: 10,
                alignment: "justify",
                margin: [0, 0, 0, 5],
                lineHeight: 1,
            },
            signature: {
                fontSize: 10,
                decoration: 'underline',
                bold: true,
                margin: [0, 10, 0, 0],
            },
        },
        defaultStyle: {
            font: "Roboto",
        },
    };

    pdfMake.createPdf(docDefinition).open();
}

export default CertificadoAnaliticoPfd
